import React from 'react';
import {Box} from '@mui/material';
import GCFLogo from '../../../assets/images/cpc/CPCIndexLogo-white.png';
import PoweredByDQ from '../../../assets/images/PoweredByDQ_white.png';

const NAVY_DEEP = '#003D69';

/**
 * Shared CPC Government Dashboard footer — CPC Index + Powered by DQ logos.
 * Pass `spaced` when the page's last section has no bottom margin of its own.
 */
const CpcFooter = ({spaced}) => (
    <Box
        component="footer"
        aria-label="Branding"
        sx={{
            background: NAVY_DEEP,
            px: 6,
            py: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            ...(spaced && {mt: 10}),
            '@media (max-width: 720px)': {
                px: 3,
                py: '32px',
                ...(spaced && {mt: 6}),
            },
        }}
    >
        <Box sx={{display: 'flex', alignItems: 'center', gap: 4}}>
            <Box
                component="img"
                src={GCFLogo}
                alt=""
                sx={{
                    height: 64,
                    width: 'auto',
                    filter: 'brightness(0) invert(1)',
                    '@media (max-width: 720px)': {height: 44},
                }}
            />
            <Box
                component="img"
                src={PoweredByDQ}
                alt="Powered by DQ"
                sx={{
                    height: 58,
                    width: 'auto',
                    '@media (max-width: 720px)': {height: 40},
                }}
            />
        </Box>
    </Box>
);

export default CpcFooter;
